export default __webpack_public_path__ + "fonts/icomoon.7a4f577f04d499b424fd753b430a76e0.woff";